import { render, staticRenderFns } from "./ContactTab.vue?vue&type=template&id=1b5d0b55&scoped=true"
import script from "./ContactTab.vue?vue&type=script&lang=js"
export * from "./ContactTab.vue?vue&type=script&lang=js"
import style0 from "./ContactTab.vue?vue&type=style&index=0&id=1b5d0b55&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d0b55",
  null
  
)

export default component.exports